import API from "../../helpers/network/http";

export default class SubscriptionService {
    // Create a method to fetch subscriptions
    static async fetchSubscriptions(): Promise<any> {

        // Call the login endpoint from the API
        const {data} = await API.get(`/subscription-plans`);
        // Return the response
        return data;

    };

    static async fetchUserSubscription(): Promise<any> {

        // Call the login endpoint from the API
        const {data} = await API.get(`/user-plans`);
        // Return the response
        return data;

    };

    // Create a method to initiate a payment for a subscription
    static async initializePayment(query: any): Promise<any> {
        // Call the login endpoint from the API
        const {data} = await API.post(`/payments/initialize`, query);
        // Return the response
        return data;

    };

}